module.exports = __webpack_public_path__ + "static/img/share-earn.b2d0acfe.png";